// extracted by mini-css-extract-plugin
export default {"ReplaceContract":"_ReplaceContract--l736D","Paragraph":"_Paragraph--xALZY","TooltipMessage":"_TooltipMessage--uQwYL"};